

function isTrialFromList(trialIndex) {
    return columnForTrial('stimFormat', trialIndex) === 'list';
}

function computeRowNoInList(trialRow) {
    const listsMeta = getListsMetaForTrial(trialRow);
   
    // rowNo is already + 1
    return listsMeta.rowNo;
}

function computeRowNo(trialRow) {
    return window.trialData['resultRowNo'][trialRow];
}

function getListsMetaForTrial(trialIndex) {
    let listsMeta = window.trialData.stimListsMeta[trialIndex];

    // if we've got a number, it represents the index where meta is found
    // as we store meta for the first row index only to void data duplication
    if (typeof listsMeta.ref !== "undefined") {
        listsMeta = {...window.trialData.stimListsMeta[listsMeta.ref], ...listsMeta};
    }

    return listsMeta;
}

function getStimsFromListsForTrial(trialIndex) {

    const listsMeta = getListsMetaForTrial(trialIndex);

    const stimsIndex = trialIndex - listsMeta.startIndex;

    return listsMeta.pickedValues[stimsIndex];
}

function getStimFromListsForTrialByIndex(trialIndex, stimIndex) {
    const stims = getStimsFromListsForTrial(trialIndex);

    return stims[stimIndex];
}